<template>
  <div class="container">
    <div class="lucky-wheel">
      <div class="lucky-title"></div>
      <div class="wheel-main">
        <div class="wheel-pointer-box">
          <div
            class="wheel-pointer"
            @click="rotate_handle()"
            :style="{transform:rotate_angle_pointer,transition:rotate_transition_pointer}"
          ></div>
        </div>
        <div class="wheel-bg" :style="{transform:rotate_angle,transition:rotate_transition}">
          <div class="prize-list">
            <div class="prize-item" v-for="(item,index) in prize_list" :key="index">
              <div class="prize-type">
                                {{item.name}}
                            </div>
              <div class="prize-pic">
                <img :src="item.icon">
              </div>
              <!-- <div class="prize-count" v-if="item.count">{{item.count}}</div> -->
                                          
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="main-bg"></div>
      <div class="bg-p"></div>
      <div class="content">
        <div class="lottery_ticket">今日免费抽奖次数： {{ lottery_ticket}}</div>
      </div>
      <div class="tip">
        <div class="tip-title">活动规则</div>
        <div class="tip-content">
          <p>1.每日签到后，即可获得一次幸运大转盘的机会，仅限当天有效，过期作废。 2.金币抽奖，每10个金豆可兑换一次大转盘机会。</p>
          <p>2.金币抽奖，每10个金豆可以兑换一次大转盘抽奖机会</p>
          <p>3.所中金豆或积分到【我的账户】中查询。累计达到100金豆及以上，可以兑换相应奖品</p>
        </div>
      </div>
    </div>
    <div class="toast" v-show="toast_control">
      <div class="toast-container">
        <img v-if="hasPrize" :src="toast_pictrue" class="toast-picture">
        <div class="close" @click="close_toast()"></div>
        <div class="toast-title">{{toast_title}}</div>
        <div class="toast-btn">
          <div class="toast-cancel" @click="close_toast">关闭</div>
        </div>
      </div>
    </div>
    <div class="toast-mask" v-show="toast_control"></div>
  </div>
</template>
<script>
import { luckWheelQueryList,
luckWheel
 } from "../api/index";

export default {
  data() {
    return {
      easejoy_bean: 0, //金豆
      lottery_ticket: 0, //抽奖次数
      prize_list: [
      ], //奖品列表
      toast_control: false, //抽奖结果弹出框控制器
      hasPrize: false, //是否中奖
      start_rotating_degree: 0, //初始旋转角度
      rotate_angle: 0, //将要旋转的角度
      start_rotating_degree_pointer: 0, //指针初始旋转角度
      rotate_angle_pointer: 0, //指针将要旋转的度数
      rotate_transition: "transform 6s ease-in-out", //初始化选中的过度属性控制
      rotate_transition_pointer: "transform 12s ease-in-out", //初始化指针过度属性控制
      click_flag: true, //是否可以旋转抽奖
      index: 0,
      curr: 1
    };
  },
  created() {
    this.init_prize_list();
  },
  computed: {
    toast_title() {
      if(this.prize_list.length==0){
        return "未中奖";
      }
      return this.prize_list[this.index].name!="未中奖"
        ? "恭喜您，获得" +this.prize_list[this.index].name
        : "未中奖";
    },
    toast_pictrue() {
      console.log(this.hasPrize);
      return this.hasPrize
        ? require("../assets/img/congratulation.png")
        : require("../assets/img/sorry.png");
    }
  },
  methods: {
    //此方法为处理奖品数据
    init_prize_list() {
      this.prize_list = [];
      let param = { gameId: "1" };
      luckWheelQueryList(param).then(res => {
        const { data } = res;
        if (data.code == "0") {
          for (var i = 0; i < data.data.length; i++) {
            let prize = {};
            prize.icon = data.data[i].picUrl;
            prize.count = data.data[i].limitNumber;
            prize.name = data.data[i].productName;
            this.prize_list.push(prize);
          }
        }
      });
    },
    rotate_handle() {
      let param = { gameId: "1" };
      luckWheel(param).then(res => {
        const { data } = res;
        if (data.code == "0") {
          this.index = data.data; //指定每次旋转到的奖品下标
          
          if(this.prize_list[this.index].name!="未中奖"){
this.hasPrize =true;
          }else{
this.hasPrize = false;
          }
          this.rotating();
        }else{
            this.$Xmessage.error({
                content: data.msg,
                duration: 2,
                callBack: this.clear
              });
        }
      });
      
    },
    rotating() {
      if (!this.click_flag) return;
      var type = 0; // 默认为 0  转盘转动 1 箭头和转盘都转动(暂且遗留)
      var during_time = 5; // 默认为1s
      var random = Math.floor(Math.random() * 7);
      var result_index = this.index; // 最终要旋转到哪一块，对应prize_list的下标
      console.log(result_index);
      var result_angle = [337.5, 292.5, 247.5, 202.5, 157.5, 112.5, 67.5, 22.5]; //最终会旋转到下标的位置所需要的度数
      var rand_circle = 6; // 附加多转几圈，2-3
      this.click_flag = false; // 旋转结束前，不允许再次触发
      if (type == 0) {
        // 转动盘子
        var rotate_angle =
          this.curr * rand_circle * 360 + result_angle[this.index];
        this.curr = this.curr + 1;
        this.start_rotating_degree = rotate_angle;
        this.rotate_angle = "rotate(" + rotate_angle + "deg)";
        // // //转动指针
        // this.rotate_angle_pointer = "rotate("+this.start_rotating_degree_pointer + 360*rand_circle+"deg)";
        // this.start_rotating_degree_pointer =360*rand_circle;
        var that = this;
        // 旋转结束后，允许再次触发
        setTimeout(function() {
          that.click_flag = true;
          that.game_over();
        }, during_time * 1000 + 1500); // 延时，保证转盘转完
      } else {
        //
      }
    },
    game_over() {
      this.toast_control = true;
      this.hasPrize = this.prize_list[this.index].name !="未中奖"?true:false;
      console.log("game_over" + this.hasPrize);
    },
    //关闭弹窗
    close_toast() {
      this.toast_control = false;
    }
  }
};
</script>
<style scoped>
.container {
  width: 100%;
}
.lucky-wheel {
  width: 100%;
  height: 15.5rem;
  background: rgb(252, 207, 133) url("./src/assets/img/color_pillar.png")
    no-repeat center bottom;
  background-size: 100%;
  padding-top: 0.3269296875rem;
}
.lucky-title {
  width: 100%;
  height: 3.794375rem;
  background: url("./src/assets/img/lucky_title.png") no-repeat center top;
  background-size: 100%;
}
.wheel-main {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.wheel-bg {
  width: 9.5rem;
  height: 9.5rem;
  background: url("./src/assets/img/draw_wheel.png") no-repeat center top;
  background-size: 100%;
  color: #fff;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  transition: transform 3s ease;
}
.wheel-pointer-box {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 100;
  transform: translate(-50%, -60%);
  width: 2.2rem;
  height: 2.2rem;
}
.wheel-pointer {
  width: 2.2rem;
  height: 2.2rem;
  background: url("./src/assets/img/draw_btn.png") no-repeat center top;
  background-size: 100%;
  transform-origin: center 60%;
}
.wheel-bg div {
  text-align: center;
}
.prize-list {
  width: 100%;
  height: 100%;
  position: relative;
}
.prize-list .prize-item {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}
.prize-list .prize-item:first-child {
  top: 0.7rem;
  left: 4rem;
  transform: rotate(20deg);
}
.prize-list .prize-item:nth-child(2) {
  top: 2rem;
  left: 5rem;
  transform: rotate(67deg);
}
.prize-list .prize-item:nth-child(3) {
  top: 3.5rem;
  left: 5rem;
  transform: rotate(-250deg);
}
.prize-list .prize-item:nth-child(4) {
  top: 4.8rem;
  left: 4rem;
  transform: rotate(-210deg);
}
.prize-list .prize-item:nth-child(5) {
  top: 4.8rem;
  left: 2.4rem;
  transform: rotate(-160deg);
}
.prize-list .prize-item:nth-child(6) {
  top: 3.6rem;
  left: 1.2rem;
  transform: rotate(-111deg);
}
.prize-list .prize-item:nth-child(7) {
  top: 1.9rem;
  left: 1.2rem;
  transform: rotate(-69deg);
}
.prize-list .prize-item:nth-child(8) {
  top: 0.7rem;
  left: 2.4rem;
  transform: rotate(-20deg);
}
.prize-item {
  width: 3rem;
  height: 4rem;
}

.prize-pic img {
  width: 1.7rem;
  height: 1rem;
  margin-top: 0.3rem;
}
.prize-count {
  font-size: 0.41rem;
}
.prize-type {
  font-size: 0.3rem;
  margin-top: 0.3rem;
}
.main {
  position: relative;
  width: 100%;
  min-height: 6.65475rem;
  background: rgb(243, 109, 86);
  padding-bottom: 0.3269880625rem;
}
.main-bg {
  width: 100%;
  height: 3.0646875rem;
  position: absolute;
  top: -1.6053125rem;
  left: 0;
  background: url("./src/assets/img/luck_bg.png") no-repeat center top;
  background-size: 100%;
}
.bg-p {
  width: 100%;
  height: 1.37765rem;
  background: rgb(252, 207, 133);
}
.content {
  position: absolute;
  top: 0.081725rem;
  left: 0;
  background: rgb(243, 109, 86);
  width: 100%;
  height: 2.4225625rem;
  font-size: 0.5rem;
  color: #ffeb39;
  padding-left: 2.7rem;
}
.content div {
  text-align: left;
}
.tip {
  position: relative;
  margin: 1.1675rem auto 0;
  width: 9rem;
  border: 1px solid #fbc27f;
}
.tip-title {
  position: absolute;
  top: -0.35rem;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 0.4rem;
  color: #fccc6e;
  background: rgb(243, 109, 86);
  padding: 0.1459375rem 0.291875rem;
}
.tip-content {
  padding: 0.3269296875rem 0.291875rem;
  font-size: 0.408625rem;
  color: #fff8c5;
  line-height: 1.3;
}
.toast-mask {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.2802);
  z-index: 10000;
  width: 100%;
  height: 100%;
}
.toast {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 20000;
  transform: translate(-50%, -50%);
  width: 7.2093125rem;
  background: #fff;
  border-radius: 0.1459375rem;
  padding: 0.1459375rem;
  background-color: rgb(252, 244, 224);
}
.toast-container {
  position: relative;
  width: 100%;
  height: 100%;
  border: 1px dotted #fccc6e;
}
.toast-picture {
  position: absolute;
  top: -3.0355rem;
  left: -0.3269005rem;
  width: 8.75625rem;
  height: 3.9986875rem;
}
.toast-pictrue-change {
  position: absolute;
  top: -0.3269005rem;
  left: -0.642125rem;
  width: 8.1725rem;
  height: 1.459375rem;
}
.toast-title {
  padding: 1.3076125rem 0;
  font-size: 0.6rem;
  color: #fc7939;
  text-align: center;
}
.toast-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.4378125rem;
}
.toast-btn div {
  background-image: -moz-linear-gradient(
    -18deg,
    rgb(242, 148, 85) 0%,
    rgb(252, 124, 88) 51%,
    rgb(252, 124, 88) 99%
  );

  background-image: -ms-linear-gradient(
    -18deg,
    rgb(242, 148, 85) 0%,
    rgb(252, 124, 88) 51%,
    rgb(252, 124, 88) 99%
  );
  background-image: -webkit-linear-gradient(
    -18deg,
    rgb(242, 148, 85) 0%,
    rgb(252, 124, 88) 51%,
    rgb(252, 124, 88) 99%
  );
  box-shadow: 0px 4px 0px 0px rgba(174, 34, 5, 0.3269);
  width: 2.1890625rem;
  height: 0.875625rem;
  border-radius: 0.875625rem;
  text-align: center;
  line-height: 0.875625rem;
  color: #fff;
}
.close {
  position: absolute;
  top: -0.4378125rem;
  right: -0.4378125rem;
  width: 1.5rem;
  height: 1.5rem;
  background: url("./src/assets/img/close_store.png") no-repeat center top;
  background-size: 100%;
}

html {
  font-family: sans-serif;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}

html,
body,
div,
span,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
abbr,
address,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
samp,
small,
strong,
sub,
sup,
var,
b,
i,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
article,
aside,
canvas,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: transparent;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section,
summary {
  display: block;
}

audio,
canvas,
progress,
video {
  display: inline-block;
  vertical-align: baseline;
}

audio:not([controls]) {
  display: none;
  height: 0;
}

[hidden],
template {
  display: none;
}

a {
  background: transparent;
  text-decoration: none;
}

a:active,
a:hover {
  outline: 0;
}

abbr[title] {
  border-bottom: 1px dotted;
}

b,
strong {
  font-weight: bold;
}

dfn {
  font-style: italic;
}

mark {
  background: #ff0;
  color: #000;
}

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sup {
  top: -0.2335em;
}

sub {
  bottom: -0.11675em;
}

img {
  border: 0;
}

svg:not(:root) {
  overflow: hidden;
}

figure {
  margin: 1em 40px;
}

hr {
  box-sizing: content-box;
  height: 0;
}

pre {
  overflow: auto;
}

code,
kbd,
pre,
samp {
  font-family: monospace, monospace;
  font-size: 1em;
}

button,
input,
optgroup,
select,
textarea {
  margin: 0;
}

button {
  overflow: visible;
  outline: none;
  border: none;
  background: none;
  list-style-type: none;
}

input:focus,
button:focus {
  outline: 0;
}

input:active,
button:active {
  outline: 0;
}

input:visited,
button:visited {
  outline: 0;
}

textarea {
  overflow: auto;
}

ul,
li,
dl,
dt,
dd {
  list-style: none;
}

.float-left {
  float: left;
}

.float-right {
  float: right;
}

.float-clear:after {
  content: "";
  display: block;
  clear: both;
}

div {
  box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/components/luckywheel.vue